<section class="solar-calculator-section">
    <div class="solar-calculator-container">
        <div class="solar-calculator">
            <!-- =====================================================
                 LEFT : CALCULATOR PANEL
            ====================================================== -->
            <div class="solar-calculator-left">
                <div class="solar-calc-header">
                    <span class="solar-calculator-label">
                        <strong>SolarCiti</strong> SOLAR CALCULATOR
                    </span>

                    <h2>
                        Calculate Your
                        <span>Solar Savings</span>
                    </h2>

                    <p>
                        Find the right solar system for your home or business
                        and discover your potential savings.
                    </p>
                </div>

                <!-- CUSTOMER TYPE -->

                <div class="solar-input-section">
                    <label class="solar-section-label"> Customer Type </label>

                    <div class="solar-customer-tabs">
                        <button
                            type="button"
                            class="solar-customer-tab"
                            [class.active]="customerType === 'home'"
                            (click)="selectCustomerType('home')"
                        >
                            <span class="solar-tab-icon">
                                <i class="fas fa-home"></i>
                            </span>

                            <span>
                                <strong>Home</strong>
                                <small>Residential</small>
                            </span>
                        </button>

                        <button
                            type="button"
                            class="solar-customer-tab"
                            [class.active]="customerType === 'commercial'"
                            (click)="selectCustomerType('commercial')"
                        >
                            <span class="solar-tab-icon">
                                <i class="fas fa-building"></i>
                            </span>

                            <span>
                                <strong>Commercial</strong>
                                <small>Business</small>
                            </span>
                        </button>
                    </div>
                </div>

                <!-- BILL INPUT -->

                <div class="solar-input-section">
                    <label for="solarMonthlyBill" class="solar-section-label">
                        Monthly Electricity Bill
                    </label>

                    <div class="solar-bill-input">
                        <div class="solar-bill-icon">₹</div>

                        <div class="solar-bill-content">
                            <span>Average monthly bill</span>

                            <input
                                type="number"
                                id="solarMonthlyBill"
                                [(ngModel)]="monthlyBill"
                                (input)="onBillChange($event)"
                                min="1"
                                step="100"
                                placeholder="Enter amount"
                            />
                        </div>
                    </div>
                </div>

                <!-- CALCULATION TYPE -->

                <div class="solar-calculation-selector">
                    <div
                        class="solar-type-label"
                        [class.active]="calculationType === 'bill'"
                    >
                        <i class="fas fa-file-invoice"></i>

                        <span>
                            <strong>Bill Amount</strong>
                            <small>Calculate from bill</small>
                        </span>
                    </div>

                    <label class="solar-switch">
                        <input
                            type="checkbox"
                            [checked]="calculationType === 'system'"
                            (change)="
                                selectCalculationType(
                                    $any($event.target).checked
                                        ? 'system'
                                        : 'bill'
                                )
                            "
                        />

                        <span class="solar-switch-slider"></span>
                    </label>

                    <div
                        class="solar-type-label"
                        [class.active]="calculationType === 'system'"
                    >
                        <i class="fas fa-solar-panel"></i>

                        <span>
                            <strong>System Size</strong>
                            <small>Calculate from kW</small>
                        </span>
                    </div>
                </div>

                <!-- SYSTEM SIZE -->

                <div
                    class="solar-system-input-box"
                    [class.show]="calculationType === 'system'"
                >
                    <label for="solarSystemSizeInput">
                        Required Solar System Size
                    </label>

                    <div class="solar-system-input">
                        <input
                            type="number"
                            id="solarSystemSizeInput"
                            [(ngModel)]="systemSize"
                            (input)="onSystemSizeChange()"
                            min="1"
                            step="0.5"
                        />

                        <span>kW</span>
                    </div>
                </div>

                <!-- INFO -->

                <div class="solar-calc-info">
                    <div class="solar-info-icon">
                        <i class="fas fa-circle-info"></i>
                    </div>

                    <p>
                        Your estimate is based on average solar generation,
                        electricity rates and system efficiency.
                    </p>
                </div>
            </div>

            <!-- =====================================================
                 RIGHT : RESULTS DASHBOARD
            ====================================================== -->

            <div class="solar-calculator-right">
                <div class="solar-results-header">
                    <div>
                        <span> YOUR SOLAR ESTIMATE </span>

                        <h3>Your Solar Savings</h3>
                    </div>

                    <div class="solar-results-status">
                        <i class="fas fa-check"></i>

                        Estimated Results
                    </div>
                </div>

                <!-- =================================================
                     PRIMARY RESULTS
                ================================================== -->

                <div class="solar-primary-results">
                    <!-- SYSTEM SIZE -->

                    <div class="solar-primary-card system-card">
                        <div class="solar-card-top">
                            <div class="solar-card-icon">
                                <i class="fas fa-solar-panel"></i>
                            </div>

                            <span class="solar-card-badge"> Recommended </span>
                        </div>

                        <div class="solar-primary-content">
                            <h4>Ideal Solar System</h4>

                            <strong>
                                {{ formatNumber(systemSize) }}
                                <small>kW</small>
                            </strong>

                            <p>Recommended system capacity</p>
                        </div>
                    </div>

                    <!-- ANNUAL SAVINGS -->

                    <div class="solar-primary-card savings-card">
                        <div class="solar-card-top">
                            <div class="solar-card-icon">
                                <i class="fas fa-piggy-bank"></i>
                            </div>

                            <span class="solar-card-badge"> Per Year </span>
                        </div>

                        <div class="solar-primary-content">
                            <h4>Estimated Annual Savings</h4>

                            <strong>
                                ₹{{ formatCurrency(annualSavings) }}
                            </strong>

                            <p>Potential electricity savings</p>
                        </div>
                    </div>
                </div>

                <!-- =================================================
                     SECONDARY METRICS
                ================================================== -->

                <div class="solar-metrics">
                    <!-- ENERGY -->

                    <div class="solar-metric-card">
                        <div class="solar-metric-icon energy-icon">
                            <i class="fas fa-bolt"></i>
                        </div>

                        <div>
                            <span> Annual Generation </span>

                            <strong>
                                {{ formatNumber(annualEnergy) }}
                                <small>Units</small>
                            </strong>
                        </div>
                    </div>

                    <!-- ROOF -->

                    <div class="solar-metric-card">
                        <div class="solar-metric-icon roof-icon">
                            <i class="fas fa-house"></i>
                        </div>

                        <div>
                            <span> Roof Space Required </span>

                            <strong>
                                {{ formatNumber(roofSpace) }}
                                <small>Sqft</small>
                            </strong>
                        </div>
                    </div>

                    <!-- SYSTEM PRICE -->

                    <div class="solar-metric-card">
                        <div class="solar-metric-icon price-icon">
                            <i class="fas fa-indian-rupee-sign"></i>
                        </div>

                        <div>
                            <span> System Price </span>

                            <strong>
                                ₹{{ formatCurrency(systemPrice) }}
                            </strong>
                        </div>
                    </div>
                </div>

                <!-- =================================================
                     COST SUMMARY
                ================================================== -->

                <div class="solar-cost-card">
                    <div class="solar-cost-header">
                        <div>
                            <span> INVESTMENT SUMMARY </span>

                            <h4>Your Solar Investment</h4>
                        </div>

                        <div class="solar-cost-header-icon">
                            <i class="fas fa-calculator"></i>
                        </div>
                    </div>

                    <div class="solar-cost-breakdown">
                        <!-- PRICE -->

                        <div class="solar-cost-item">
                            <div class="solar-cost-item-icon">
                                <i class="fas fa-indian-rupee-sign"></i>
                            </div>

                            <div>
                                <span> System Price </span>

                                <small> Excluding Subsidy & GST </small>
                            </div>

                            <strong>
                                ₹{{ formatCurrency(systemPrice) }}
                            </strong>
                        </div>

                        <div class="solar-cost-line"></div>

                        <!-- SUBSIDY -->

                        <div class="solar-cost-item">
                            <div class="solar-cost-item-icon green">
                                <i class="fas fa-hand-holding-dollar"></i>
                            </div>

                            <div>
                                <span> Subsidy + Discount </span>

                                <small> Government + SOLARCITI </small>
                            </div>

                            <strong class="saving-value">
                                − ₹{{
                                    formatCurrency(subsidy + solarCitiDiscount)
                                }}
                            </strong>
                        </div>

                        <div class="solar-cost-line"></div>

                        <!-- EFFECTIVE -->

                        <div class="solar-cost-item effective">
                            <div class="solar-cost-item-icon orange">
                                <i class="fas fa-wallet"></i>
                            </div>

                            <div>
                                <span> Effective Cost </span>

                                <small> Taxes + Net-metering extra </small>
                            </div>
                            <strong>
                                ₹{{ formatCurrency(effectiveCost) }}
                            </strong>
                        </div>
                    </div>
                </div>

                <!-- FOOTER -->
                <div class="solar-results-footer">
                    <div>
                        <i class="fas fa-shield-check"></i>
                        Smart Solar Estimate
                    </div>
                    <span>
                        Actual savings may vary based on usage & location
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
